import React from 'react';
import {
  GlobeAltIcon,
  BuildingOffice2Icon,
  ServerStackIcon,
  TruckIcon,
  ExclamationTriangleIcon,
  ArrowsPointingOutIcon,
  CpuChipIcon,
  ShieldCheckIcon,
  ArrowPathIcon,
} from '@heroicons/react/24/outline';
import { IndustryPageTemplate } from '../../components/page-templates/MarketPageTemplates';

const challenges = [
  {
    icon: GlobeAltIcon,
    title: 'Global Hardware Rollouts',
    description: 'Coordinating deployments across distributed offices in dozens of countries with different regulations.',
  },
  {
    icon: ArrowsPointingOutIcon,
    title: 'Rapid Scaling',
    description: 'Fast device fulfilment needed as your workforce and infrastructure grow unpredictably.',
  },
  {
    icon: ArrowPathIcon,
    title: 'Multi-Geography Lifecycle',
    description: 'Managing device procurement, deployment, and retirement across multiple geographies simultaneously.',
  },
  {
    icon: ExclamationTriangleIcon,
    title: 'Cross-Border Compliance',
    description: 'Navigating import/export regulations and trade compliance when shipping tech equipment internationally.',
  },
];

const solutions = [
  {
    icon: ShieldCheckIcon,
    title: 'IOR/EOR for 140+ Countries',
    description: 'Full importer/exporter of record services with regulatory expertise across all major markets.',
  },
  {
    icon: BuildingOffice2Icon,
    title: 'Global Warehousing & Regional Hubs',
    description: 'Strategic warehouse locations enabling faster fulfilment and regional consolidation.',
  },
  {
    icon: CpuChipIcon,
    title: 'Device Staging & Configuration',
    description: 'Pre-configured devices shipped deployment-ready with your software, settings, and security policies.',
  },
  {
    icon: TruckIcon,
    title: 'Last-Mile Delivery with SLAs',
    description: 'Time-definite delivery to end users and offices with 8, 12, and 24-hour SLA options.',
  },
  {
    icon: ServerStackIcon,
    title: 'ITAM Platform Integration',
    description: 'Seamless integration with your ICT asset management platform for real-time visibility and control.',
  },
  {
    icon: ArrowPathIcon,
    title: 'Reverse Logistics & Data Wiping',
    description: 'End-of-life device recovery, certified data destruction, and responsible recycling worldwide.',
  },
];

const stats = [
  { value: '140+', label: 'Countries' },
  { value: '6', label: 'Global Offices' },
  { value: '10+', label: 'Years Experience' },
  { value: '6,500+', label: 'Field Workers' },
];

const TechnologySoftware: React.FC = () => (
  <IndustryPageTemplate
    eyebrow="Technology & Software"
    title="ICT Logistics for Technology & Software Companies"
    highlight="Technology & Software"
    description="Move, deploy, and manage hardware globally, from prototyping to production rollouts, with one accountable logistics partner."
    heroIcon={CpuChipIcon}
    heroAccentIcon={GlobeAltIcon}
    challengesIntro="Scaling technology operations globally creates logistics complexity that slows you down."
    challenges={challenges}
    solutionsIntro="End-to-end ICT logistics built for the speed and scale technology companies demand."
    solutions={solutions}
    useCase="Whether you are shipping laptops to a remote workforce or deploying servers to a new data centre, TrueLog ensures every device arrives configured, compliant, and on time."
    stats={stats}
    ctaTitle="Ready to streamline your global ICT logistics?"
    ctaDescription="Let TrueLog handle the complexity of global hardware deployment so your team can focus on building great products."
  />
);

export default TechnologySoftware;
